export default __webpack_public_path__ + "static/media/Scenario4_Gif.88c5e0eb.gif";